import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-striped table-sm" }
const _hoisted_3 = { class: "align-middle text-center small" }
const _hoisted_4 = { class: "align-middle" }
const _hoisted_5 = { class: "text-nowrap" }
const _hoisted_6 = { class: "align-middle small" }
const _hoisted_7 = { class: "list-unstyled d-inline" }
const _hoisted_8 = ["href", "title"]
const _hoisted_9 = { class: "align-middle text-end" }
const _hoisted_10 = { class: "d-flex text-nowrap" }
const _hoisted_11 = { class: "flex-fill me-4" }
const _hoisted_12 = { class: "align-middle text-end" }
const _hoisted_13 = { class: "d-flex text-nowrap fw-bold" }
const _hoisted_14 = { class: "flex-fill me-4" }
const _hoisted_15 = { class: "small" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex text-nowrap small muted"
}
const _hoisted_17 = { class: "flex-fill me-4" }
const _hoisted_18 = { class: "small" }
const _hoisted_19 = { class: "align-middle" }
const _hoisted_20 = { class: "ms-4 me-1" }
const _hoisted_21 = { class: "text-center small flex-fill me-4 text-truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
        _createElementVNode("tr", { class: "fw-bold" }, [
          _createElementVNode("th", { class: "col-2 text-center" }, "Fecha"),
          _createElementVNode("th", { class: "col-3" }, "Concepto"),
          _createElementVNode("th", {
            class: "",
            style: {"--max-width":"10rem"}
          }, "TX Hash"),
          _createElementVNode("th", { class: "col-2 col-xl-2 text-center" }, "Valor"),
          _createElementVNode("th", { class: "col-2 col-xl-2 text-center" }, "Pagado"),
          _createElementVNode("th", { class: "col-2 col-xl-2 text-center" }, "Status")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPayments, (p) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "",
            key: p._id
          }, [
            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.formatDate(p._id)), 1),
            _createElementVNode("td", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(p.concept), 1)
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createElementVNode("ul", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.blockchainTransactions, (tran, tranid) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "text-truncate",
                    style: {"max-width":"15rem"},
                    key: tranid
                  }, [
                    (tranid.toString() != 'gtr_FIX_ACTIVATION')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: 
                    'https://blockchair.com/es/bitcoin/transaction/' + tranid
                  ,
                          target: "_blank",
                          class: "link-success",
                          title: tranid.toString()
                        }, _toDisplayString(tranid), 9, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.toTwoDecimals(Number(p.originalAmount))), 1)
              ])
            ]),
            _createElementVNode("td", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ms-4 me-1" }, [
                  _createElementVNode("i", { class: "fab fa-btc" })
                ], -1)),
                _createElementVNode("span", _hoisted_14, [
                  _createTextVNode(_toDisplayString(p.paidAmount.toFixed(8)) + " ", 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(p.paidCurrency), 1)
                ])
              ]),
              (p.processingAmount && p.processingAmount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ms-4 me-1" }, [
                      _createElementVNode("i", { class: "fab fa-btc" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_17, [
                      _createTextVNode(_toDisplayString(p.processingAmount.toFixed(8)) + " ", 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(p.paidCurrency), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("td", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass('text-nowrap ' + _ctx.statusColorClass(p.status))
              }, [
                _createElementVNode("span", _hoisted_20, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.statusIconClass(p.status) + ' me-1')
                  }, null, 2)
                ]),
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.translateStatus(p.status)), 1)
              ], 2)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}